<template>
  <div class="row align-center" :class="colorClass">
    <div class="small-12 medium-12 large-11 columns header_top">
      <div class="row"
           :class="{
            [colorClass]: is_mobile && menuOpen,
            'secondColor': is_mobile && menuOpen
          }">
        <hamburgerMenu
            :is-open="menuOpen"
            @click="menuOpen = !menuOpen" />
          <div class="small-12 medium-4 large-3 columns banner_logo">
            <router-link
                v-if="showApresentacao"
                :to="{ name: `apresentacao`, params: { id: name }}"
                class="menu_item"
                @click="menuOpen = false">
              <img :src="urlimage">
            </router-link>
            <img v-else :src="urlimage">
          </div>
          <div class="small-12 medium-8 large-9 columns banner_menu">
            <div class="departamentoMenu">
              <router-link
                  v-if="showApresentacao"
                  :to="{ name: `apresentacao`, params: { id: name }}"
                  class="menu_item"
                  @click="menuOpen = false">
                {{ $translate("UMA_LANG_DEPARTAMENTOS_APRESENTACAO") }}
              </router-link>
              <router-link
                  v-if="this.$store.state.departamento?.Texto.length > 0 || showDestaques || showTestemunhos || cursos.length > 0"
                  :to="{ name: `pessoas`, params: { id: name }}"
                  class="menu_item"
                  @click="menuOpen = false">
                    {{ $translate("UMA_LANG_DEPARTAMENTOS_PESSOAS") }}
              </router-link>
              <router-link
                  v-if="showDestaques"
                  :to="{ name: `noticias`, params: { id: name }}"
                  class="menu_item"
                  @click="menuOpen = false">
                    {{ $translate("UMA_LANG_DEPARTAMENTOS_NOTICIAS") }}
              </router-link>
              <router-link
                  v-if="showTestemunhos"
                  :to="{ name: `testemunhos`, params: { id: name }}"
                  class="menu_item"
                  @click="menuOpen = false">
                    {{ $translate("UMA_LANG_DEPARTAMENTOS_TESTEMUNHOS") }}
              </router-link>
            </div>
            <div class="departamentoMenu mobile secondColor"
                 :class="[colorClass]"
                 v-if="menuOpen">
              <div class="linkWrapper">
                <router-link
                    v-if="this.$store.state.departamento?.Texto.length > 0 || showDestaques || showTestemunhos"
                    :to="{ name: `apresentacao`, params: { id: name }}"
                    class="menu_item"
                    @click="menuOpen = false">
                  {{ $translate("UMA_LANG_DEPARTAMENTOS_APRESENTACAO") }}
                </router-link>
              </div>
              <div class="linkWrapper">
                <router-link
                    v-if="this.$store.state.departamento?.Texto.length > 0 || showDestaques || showTestemunhos"
                    :to="{ name: `pessoas`, params: { id: name }}"
                    class="menu_item"
                    @click="menuOpen = false">
                  {{ $translate("UMA_LANG_DEPARTAMENTOS_PESSOAS") }}
                </router-link>
              </div>
              <div class="linkWrapper">
                <router-link
                    v-if="showDestaques"
                    :to="{ name: `noticias`, params: { id: name }}"
                    class="menu_item"
                    @click="menuOpen = false">
                  {{ $translate("UMA_LANG_DEPARTAMENTOS_NOTICIAS") }}
                </router-link>
              </div>
              <div class="linkWrapper">
                <router-link
                    v-if="showTestemunhos"
                    :to="{ name: `testemunhos`, params: { id: name }}"
                    class="menu_item"
                    @click="menuOpen = false">
                  {{ $translate("UMA_LANG_DEPARTAMENTOS_TESTEMUNHOS") }}
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="row align-center" :class="colorClass">
    <div class="small-12 medium-10 large-10 columns banner_titles">
      <router-link v-if="showApresentacao" :to="{ name: `apresentacao`, params: { id: name }}">
        <h1>{{ title }}</h1>
      </router-link>
      <h1 v-else>{{ title }}</h1>
    </div>
  </div>
  <div class="row align-center btnwrapper" :class="colorClass">
    <div class="small-12 medium-10 large-10 columns banner_titles">
      <router-link to="/" class="backbtn">
        <i class="ms-Icon ms-Icon--ArrowTallDownLeft"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import hamburgerMenu from "./hamburger";

export default {
  name: 'HeaderDep',
  components:{
    hamburgerMenu
  },
  props: ['title','colorClass','name','urlimage',"showDestaques",
    "showTestemunhos","mainColor","showApresentacao","cursos"],
  data(){
    return {
      menuOpen: false,
      windowWidth: window.outerWidth,
      color: ""
    }
  },
  computed:{
    is_mobile() {
      return this.windowWidth <= 767;
    }
  },
  created(){
    this.color = this.mainColor;
    window.addEventListener("resize", this.myEventHandler);
  },
  unmounted() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods:{
    myEventHandler() {
      this.windowWidth = window.outerWidth;
    },
  }
}
</script>


<style scoped>

.backbtn{
  border: 1.5px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  transition: all .5s ease-in-out;
}

.backbtn i{
  transform: rotate(45deg);
  color: white;
}

.backbtn:hover {
  background: white;
}

.backbtn:hover i {
  color: v-bind('color');
}

.btnwrapper{
  padding-bottom: 20px;
}

.banner_logo{
  position: relative;
}

.banner_menu{
  padding-top: 35px;
  padding-right: 50px;
}

.banner_titles h1 {
  text-align: center;
  font-size: 60px;
  color: #ffffff;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: 'Montserrat Semibold';
}

.banner_menu .departamentoMenu.mobile{
  display: none;
}

.banner_menu .departamentoMenu{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 45px;
}

.departamentoMenu .menu_item{
  color: white;
  font-family: "Montserrat";
  padding-left: 1px;
  padding-right: 1px;
  font-size: 18px;
  margin-left: 60px;
  position: relative;
}

.departamentoMenu .menu_item:after{
  display:block;
  content: '';
  border-bottom: 2px solid white;
  transform: scaleX(0);
  transition: transform 250ms ease-in-out;
  transform-origin:  100% 0;
}

.departamentoMenu .menu_item:hover:after{
  transform: scaleX(1);
  transform-origin:  0 50%;
}

.departamentoMenu .menu_item.router-link-active:after{
  display:block;
  content: '';
  border-bottom: 2px solid white;
  transform: scaleX(1);
}

.banner_logo img {
  height: 60px;
  margin-top: 25px;
  margin-left: 50px;
}


.banner_titles h1 {
  padding-left: 70px;
  padding-right: 70px;
  line-height: 1.15;
}

.backbtn i {
  font-weight: 600;
}


/*Responsive - ecrãs desktop pequenos*/
@media (max-width: 1440px) {

  .banner_titles h1 {
    font-size: 52px;
    padding-left: 80px;
    padding-right: 80px;
    line-height: 56px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .banner_logo img {
    margin-left: 0;
  }

  .banner_menu {
    padding-right: 0;
    padding-top: 27px;
  }

  .departamentoMenu .menu_item {
    font-size: 16px;
  }

}

@media (max-width: 1300px) {

  .banner_titles h1 {
    padding-left: 60px;
    padding-right: 60px;
    padding-bottom: 2px;
    font-size: 49px;
    line-height: 49px;
  }

  .btnwrapper {
    padding-bottom: 10px;
  }

}


@media (max-width: 1125px) {
  .departamentoMenu .menu_item {
    margin-left: 50px;
  }

  .banner_titles h1 {
    font-size: 50px;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .btnwrapper {
    padding-bottom: 10px;
  }

  .backbtn i {
    font-size: 14px;
  }

  .backbtn {
    width: 35px;
    height: 35px;
  }

}

/*Responsive - ipad*/
@media (max-width: 1025px) {
  .banner_titles h1 {
    font-size: 40px;
    padding-left: 0;
    padding-right: 0;
    line-height: 42px;
  }

  .departamentoMenu .menu_item {
    margin-left: 40px;
    font-size: 15px;
  }

  .banner_menu {
    padding-top: 20px;
  }

  .banner_logo img {
    height: 55px;
    margin-top: 13px;
  }

  .banner_titles h1 {
    padding-top: 0px;
    padding-bottom: 12px;
  }

}

@media (max-width: 935px) {
  .departamentoMenu .menu_item {
    margin-left: 19px;
    font-size: 14px;
  }

  .banner_menu {
    margin-left: -25px;
    padding-top: 25px;
  }

  .banner_logo img {
    height: 50px;
    margin-top: 16px;
  }

  .header_top .row {
    padding-left: 10px;
  }

  .banner_menu .departamentoMenu {
    margin-bottom: 40px;
  }

  .banner_titles h1 {
    padding-bottom: 16px;
  }

}

/*Responsive - iphone*/
@media (max-width: 767px) {
  .banner_titles h1 {
    font-size: 20px;
    padding-top: 10px;
    padding-bottom: 15px;
    padding-left: 20px;
    padding-right: 20px;
    line-height: 24px;
    letter-spacing: normal;
    padding-bottom: 30px;
  }

  .banner_logo img {
    height: 35px;
  }

  .banner_menu .departamentoMenu{
    display: none;
  }

  .banner_menu .departamentoMenu.mobile{
    display: block;
  }

  .departamentoMenu{
    flex-direction: column;
  }

  .departamentoMenu.mobile .menu_item{
    display: block;
    /*flex: 1;*/
    /*width: 100%;*/
    border-bottom: 0;
    margin-bottom: 10px;
  }

  .linkWrapper{
    display: flex;
    flex: 1;
    width: 100%;
  }

  .banner_menu {
    padding-top: 0px;
  }

  .banner_menu .departamentoMenu {
    margin-bottom: 0px;
  }

  .header_top {
    padding-right: 0;
    padding-left: 0;
    position: relative;
  }

  .banner_menu {
    padding-left: 0;
  }

  .backbtn {
    display: none;
  }

  .banner_titles h1 {
    font-family: 'Montserrat';
    padding-top: 15px;
  }

  .departamentoMenu .linkWrapper:first-of-type {
    padding-top: 35px;
  }

  .departamentoMenu .linkWrapper:last-of-type {
    padding-bottom: 20px;
  }

  .departamentoMenu .menu_item {
    margin-bottom: 18px;
  }

  .banner_menu .departamentoMenu.mobile {
    padding-left: 40px;
  }

}
</style>
